import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-112471b0")

_pushScopeId("data-v-112471b0")
const _hoisted_1 = { class: "builder-container" }
const _hoisted_2 = { ref: "builderForm" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "block-title" }, "DETAILS", -1)
const _hoisted_4 = { class: "item-title item-label display-flex align-items-center" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { style: {"margin-right":"8px"} }, "Purchase Type", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("option", { value: "direct" }, "Direct", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("option", { value: "distribution" }, "Distribution", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("option", { value: "buyingGroup" }, "Buying Group", -1)
const _hoisted_9 = { class: "item-title item-label display-flex align-items-center" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { style: {"margin-right":"8px"} }, "Buying Group", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("option", { value: "uag" }, "UAG", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("option", { value: "carecraft" }, "Carecraft", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("option", { value: "mpg" }, "MPG", -1)
const _hoisted_14 = { class: "item-title item-label display-flex align-items-center" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { style: {"margin-right":"8px"} }, "Sales Email", -1)
const _hoisted_16 = {
  class: "display-flex",
  style: {"padding-top":"20px"}
}
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Save")
const _hoisted_19 = {
  class: "jobs-container",
  style: {"margin":"0 20px 0 0"}
}
const _hoisted_20 = /*#__PURE__*/_createTextVNode("JOBS")
const _hoisted_21 = { class: "text-align-center" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Add Job")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_f7_link = _resolveComponent("f7-link")
  const _component_f7_navbar = _resolveComponent("f7-navbar")
  const _component_f7_list_input = _resolveComponent("f7-list-input")
  const _component_f7_list_item = _resolveComponent("f7-list-item")
  const _component_f7_list = _resolveComponent("f7-list")
  const _component_f7_accordion_content = _resolveComponent("f7-accordion-content")
  const _component_f7_toggle = _resolveComponent("f7-toggle")
  const _component_f7_button = _resolveComponent("f7-button")
  const _component_f7_popover = _resolveComponent("f7-popover")
  const _component_f7_card = _resolveComponent("f7-card")
  const _component_f7_block_title = _resolveComponent("f7-block-title")
  const _component_f7_page = _resolveComponent("f7-page")

  return (_openBlock(), _createBlock(_component_f7_page, null, {
    default: _withId(() => [
      _createVNode(_component_f7_navbar, {
        title: _ctx.newBuilder ? 'New Builder' : _ctx.builder.name ?? 'Loading',
        subtitle: _ctx.builder.customer.name
      }, {
        left: _withId(() => [
          _createVNode(_component_f7_link, {
            class: "mobile-only",
            "icon-only": "",
            "icon-f7": "chevron_left",
            href: "/builders"
          })
        ]),
        _: 1
      }, 8, ["title", "subtitle"]),
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_f7_card, null, {
          default: _withId(() => [
            _createVNode("form", _hoisted_2, [
              _createVNode(_component_f7_list, {
                "no-hairlines": "",
                "no-hairlines-between": ""
              }, {
                default: _withId(() => [
                  _hoisted_3,
                  (_ctx.newBuilder)
                    ? (_openBlock(), _createBlock(_component_f7_list_input, {
                        key: 0,
                        outline: "",
                        label: "ID",
                        type: "text",
                        placeholder: "Enter user ID",
                        value: _ctx.builder.builderID,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.builder.builderID = $event)),
                        pattern: "^[A-Za-z0-9]+$",
                        "error-message": "user ID can only contain alpha-numeric characters.",
                        required: "",
                        validate: ""
                      }, null, 8, ["value"]))
                    : (_openBlock(), _createBlock(_component_f7_list_input, {
                        key: 1,
                        outline: "",
                        label: "ID",
                        type: "text",
                        placeholder: "Enter user ID",
                        value: _ctx.builderID,
                        readonly: ""
                      }, null, 8, ["value"])),
                  _createVNode(_component_f7_list_input, {
                    outline: "",
                    label: "Full name",
                    type: "text",
                    placeholder: "John Doe",
                    value: _ctx.builder.name,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.builder.name = $event)),
                    required: "",
                    validate: ""
                  }, null, 8, ["value"]),
                  _createVNode(_component_f7_list_input, {
                    outline: "",
                    readonly: "",
                    label: "Company name",
                    type: "text",
                    placeholder: "Pool Company LLC",
                    value: _ctx.builder.customer.name,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_ctx.builder.customer.name = $event)),
                    required: "",
                    validate: ""
                  }, null, 8, ["value"]),
                  _createVNode(_component_f7_list_input, {
                    outline: "",
                    label: "Email",
                    type: "email",
                    value: _ctx.builder.email,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_ctx.builder.email = $event)),
                    required: "",
                    validate: "",
                    readonly: !_ctx.newBuilder
                  }, null, 8, ["value", "readonly"]),
                  _createVNode(_component_f7_list_input, {
                    outline: "",
                    label: "Phone",
                    type: "text",
                    placeholder: "e.g. xxx-xxx-xxxx",
                    value: _ctx.builder.phone,
                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (_ctx.builder.phone = $event)),
                    pattern: "^[\\+]?[(]?[0-9]{3}[)]?[-\\s\\.]?[0-9]{3}[-\\s\\.]?[0-9]{4,6}$"
                  }, null, 8, ["value"]),
                  _createVNode(_component_f7_list_item, {
                    "accordion-item": "",
                    title: "Permissions",
                    footer: _ctx.permissionsSummary
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_f7_accordion_content, null, {
                        default: _withId(() => [
                          _createVNode(_component_f7_list, null, {
                            default: _withId(() => [
                              _createVNode(_component_f7_list_item, {
                                checkbox: "",
                                checked: _ctx.builder.roles.canViewWarehouse,
                                "onUpdate:checked": _cache[6] || (_cache[6] = ($event: any) => (_ctx.builder.roles.canViewWarehouse = $event)),
                                title: "Warehouse",
                                footer: "Access the online warehouse."
                              }, null, 8, ["checked"]),
                              _createVNode(_component_f7_list_item, {
                                checkbox: "",
                                checked: _ctx.builder.roles.canSubmitJobs,
                                "onUpdate:checked": _cache[7] || (_cache[7] = ($event: any) => (_ctx.builder.roles.canSubmitJobs = $event)),
                                title: "Jobs",
                                footer: "Submit new jobs and purchase job BOMs."
                              }, null, 8, ["checked"]),
                              _createVNode(_component_f7_list_item, {
                                checkbox: "",
                                checked: _ctx.builder.roles.canViewLoyaltyProgram,
                                "onUpdate:checked": _cache[8] || (_cache[8] = ($event: any) => (_ctx.builder.roles.canViewLoyaltyProgram = $event)),
                                title: "Loyalty Program",
                                footer: "View the loyalty points page."
                              }, null, 8, ["checked"]),
                              _createVNode(_component_f7_list_item, {
                                checkbox: "",
                                checked: _ctx.builder.roles.creditTerms,
                                "onUpdate:checked": _cache[9] || (_cache[9] = ($event: any) => (_ctx.builder.roles.creditTerms = $event)),
                                title: "Credit Terms",
                                footer: "Make purchases without paying during checkout."
                              }, null, 8, ["checked"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["footer"]),
                  _createVNode(_component_f7_list_item, {
                    title: "Loyalty Points",
                    link: `/builders/${_ctx.builder.builderID}/rewards`,
                    footer: "View and edit points and add sales accounts."
                  }, null, 8, ["link"]),
                  (_ctx.newBuilder)
                    ? (_openBlock(), _createBlock(_component_f7_list_input, {
                        key: 2,
                        outline: "",
                        label: "Fishbowl customer number",
                        type: "text",
                        placeholder: "Enter customer number",
                        value: _ctx.newCustomerNumber,
                        "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => (_ctx.newCustomerNumber = $event)),
                        required: "",
                        validate: ""
                      }, null, 8, ["value"]))
                    : (_openBlock(), _createBlock(_component_f7_list_input, {
                        key: 3,
                        outline: "",
                        readonly: "",
                        label: "Fishbowl customer number",
                        type: "text",
                        value: _ctx.builder.customer.number,
                        "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => (_ctx.builder.customer.number = $event))
                      }, null, 8, ["value"])),
                  _createVNode(_component_f7_list_input, {
                    type: "select",
                    required: "",
                    validate: "",
                    outline: "",
                    value: _ctx.builder.purchaseType,
                    "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => (_ctx.builder.purchaseType = $event))
                  }, {
                    label: _withId(() => [
                      _createVNode("div", _hoisted_4, [
                        _hoisted_5,
                        _createVNode(_component_f7_link, {
                          tooltip: "Direct: The builder will purchase BOMs directly from this PUL Portal.<br> Distribution: The builder will purchase BOMs from a distribution channel.<br> Buying Group: See buying group details.",
                          "icon-f7": "info_circle",
                          "icon-size": "16"
                        })
                      ])
                    ]),
                    default: _withId(() => [
                      _hoisted_6,
                      _hoisted_7,
                      _hoisted_8
                    ]),
                    _: 1
                  }, 8, ["value"]),
                  _createVNode(_component_f7_list_input, {
                    type: "select",
                    required: _ctx.builder.purchaseType === 'buyingGroup',
                    validate: "",
                    outline: "",
                    value: _ctx.builder.buyingGroupName,
                    "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => (_ctx.builder.buyingGroupName = $event)),
                    disabled: _ctx.builder.purchaseType !== 'buyingGroup'
                  }, {
                    label: _withId(() => [
                      _createVNode("div", _hoisted_9, [
                        _hoisted_10,
                        _createVNode(_component_f7_link, {
                          tooltip: "UAG: The builder will purchase BOMs directly from UAG.<br> Carecraft: The builder will purchase BOMs directly from Carecraft.<br> Mpg: The builder will submit purchase requests through the portal.",
                          "icon-f7": "info_circle",
                          "icon-size": "16"
                        })
                      ])
                    ]),
                    default: _withId(() => [
                      _hoisted_11,
                      _hoisted_12,
                      _hoisted_13
                    ]),
                    _: 1
                  }, 8, ["required", "value", "disabled"]),
                  _createVNode(_component_f7_list_input, {
                    outline: "",
                    type: "email",
                    placeholder: "Salesperson email",
                    value: _ctx.builder.salesEmail,
                    "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => (_ctx.builder.salesEmail = $event)),
                    validate: ""
                  }, {
                    label: _withId(() => [
                      _createVNode("div", _hoisted_14, [
                        _hoisted_15,
                        _createVNode(_component_f7_link, {
                          tooltip: "This email address will be bcc'd on every<br> job update email the builder recieves.",
                          "icon-f7": "info_circle",
                          "icon-size": "16"
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["value"]),
                  _createVNode(_component_f7_list_input, {
                    outline: "",
                    label: "Notes",
                    type: "textarea",
                    placeholder: "Notes",
                    value: _ctx.builder.notes,
                    "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => (_ctx.builder.notes = $event))
                  }, null, 8, ["value"]),
                  _createVNode(_component_f7_list_item, {
                    title: "Split Orders Into Packages",
                    footer: "Split orders into multiple packages with different shipping dates and addresses"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_f7_toggle, {
                        checked: _ctx.builder.roles.canSplitOrders,
                        "onUpdate:checked": _cache[16] || (_cache[16] = ($event: any) => (_ctx.builder.roles.canSplitOrders = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (!_ctx.newBuilder)
                    ? (_openBlock(), _createBlock(_component_f7_list_item, {
                        key: 4,
                        title: "Email Notifications",
                        footer: "Order update, password reset, and account activation emails"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_f7_toggle, {
                            checked: _ctx.builder.receiveEmails,
                            "onUpdate:checked": _cache[17] || (_cache[17] = ($event: any) => (_ctx.builder.receiveEmails = $event))
                          }, null, 8, ["checked"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ], 512),
            _createVNode("div", _hoisted_16, [
              (!_ctx.newBuilder)
                ? (_openBlock(), _createBlock(_component_f7_button, {
                    key: 0,
                    "popover-open": ".builder-menu",
                    "icon-f7": "ellipsis"
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_f7_button, {
                onClick: _ctx.getBuilder,
                style: {"flex":"2"},
                color: "red"
              }, {
                default: _withId(() => [
                  _hoisted_17
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_f7_button, {
                onClick: _ctx.save,
                style: {"flex":"3"},
                fill: ""
              }, {
                default: _withId(() => [
                  _hoisted_18
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_f7_popover, { class: "builder-menu" }, {
                default: _withId(() => [
                  _createVNode(_component_f7_list, { "no-chevron": "" }, {
                    default: _withId(() => [
                      _createVNode(_component_f7_list_item, {
                        link: "#",
                        "popover-close": "",
                        title: "Delete Builder",
                        onClick: _ctx.deleteBuilder
                      }, null, 8, ["onClick"]),
                      _createVNode(_component_f7_list_item, {
                        link: "#",
                        "popover-close": "",
                        title: "Send password reset email",
                        onClick: _ctx.resetPassword
                      }, null, 8, ["onClick"]),
                      _createVNode(_component_f7_list_item, {
                        link: "#",
                        "popover-close": "",
                        title: "Change Password",
                        onClick: _ctx.openChangePasswordDialog
                      }, null, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createVNode("div", _hoisted_19, [
          _createVNode(_component_f7_block_title, null, {
            default: _withId(() => [
              _hoisted_20
            ]),
            _: 1
          }),
          _withDirectives(_createVNode("p", _hoisted_21, " This builder doesn't have any jobs yet ", 512), [
            [_vShow, !_ctx.newBuilder && !_ctx.fetching && _ctx.jobs.length == 0]
          ]),
          _createVNode(_component_f7_list, {
            "no-hairlines": "",
            class: "no-margin"
          }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.jobs, (j) => {
                return (_openBlock(), _createBlock(_component_f7_list_item, {
                  title: j.name,
                  footer: j.ID,
                  key: j.ID,
                  link: '/jobs/' + j.ID,
                  view: ".view-main"
                }, null, 8, ["title", "footer", "link"]))
              }), 128))
            ]),
            _: 1
          }),
          (!_ctx.newBuilder && _ctx.fetching)
            ? (_openBlock(), _createBlock(_component_f7_list, {
                key: 0,
                "no-hairlines": "",
                class: "skeleton-text skeleton-effect-wave no-margin"
              }, {
                default: _withId(() => [
                  _createVNode(_component_f7_list_item, {
                    title: "Title and beans",
                    footer: "Footer"
                  }),
                  _createVNode(_component_f7_list_item, {
                    title: "Title and even mOrE bEans",
                    footer: "Foooooooooooter"
                  }),
                  _createVNode(_component_f7_list_item, {
                    title: "Title and more beans",
                    footer: "Footer"
                  }),
                  _createVNode(_component_f7_list_item, {
                    title: "Title and no beans",
                    footer: "Footooer"
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_f7_button, {
            disabled: _ctx.newBuilder,
            style: {"margin":"20px 0"},
            href: '/jobs/new?builderID=' + _ctx.builderID
          }, {
            default: _withId(() => [
              _hoisted_22
            ]),
            _: 1
          }, 8, ["disabled", "href"])
        ])
      ])
    ]),
    _: 1
  }))
})